import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/**
 * Vereinfachtes 12-Spalten-Grid (MUI-`Grid`-Ersatz). `container` spannt das
 * Raster, `item` belegt `xs`/`md` Spalten. Reicht fuer Karten-/Formularraster.
 */
export const Grid = forwardRef(function Grid({ container, item, xs, md, spacing, className, style, ...rest }, ref) {
    const s = { ...style };
    if (container && spacing != null)
        s.gap = `${spacing * 8}px`;
    return (_jsx("div", { ref: ref, className: cn(container && 'sec-grid', item && xs && `sec-col-${xs}`, item && md && `sec-col-md-${md}`, className), style: s, ...rest }));
});
